export function getFilterName(type: string) {
    switch (type) {
        case "shape":
            return "Фигура";
        case "text":
        case "textV2":
            return "Текст";
        case "image":
            return "Изображение";
        case "sketch":
            return "Перо";
        case "arrow":
            return "Соединительная линия";
        case "mindMap":
            return "Интеллект-карта";
        case "sticker":
            return "Стикер";
        case "table":
            return "Таблица";
        case "card":
            return "Карточка";
        case "group":
            return "Группа";
        case "frame":
            return "Фрейм";
        case "presentation":
            return "Презентация";
        case "comment":
            return "Комментарий";
        case "embed":
            return "Встраиваемый контент";
        case "documentViewer":
            return "Документ";
        case "emoji":
            return "Эмодзи";
        default:
            return type;
    }
}
